import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Counter, COUNTER_TYPE, Divider } from 'veloe-ds';
import ScriptTag from 'react-script-tag';

import './qtdProduto.scss';

import { eventTrackBasic, eventTrackRoute } from '../../utils/pushDataLayer.js';
import {
  salvarListaProdutos,
  totalProdutos,
} from '../../actions/pedidoActions';
import { salvarListaProdutosAsync } from '../../actions/asyncActions';
import { veloeGraphQlApi } from '../../api/graphql/graphQLAPI';
import qtdProdutoFCG from '../../mutations/qtdProduto';
import { withSnackbar } from 'notistack';
import { APP_PAGES } from '../../routes';
import { modalInformativo } from '../../Components/Modais';

/**
 * Exibe as opções de quantidade para cada produto selecionado
 * */
class QtdProduto extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tags: 1,
      listaDeProdutosSelecionados: this.props.pedido.listaDeProdutos,
      quantidadeMaximaTagsPorClienteQuandoNaoTemTAG: 2,
      quantidadeMaximaTagsPorClienteQuandoTemTAG: 10,
    };
  }

  componentDidMount = () => {
    const { history } = this.props;
    const proposta = JSON.parse(localStorage.getItem('proposta'));
    if (!proposta) {
      history.push(APP_PAGES.CADASTRO);
    }
    eventTrackRoute('quantidade-produto');
  };

  somaTotais = () => {
    const { totalProdutos } = this.props;
    const { listaDeProdutosSelecionados } = this.state;
    let valorTotal = 0;
    let qtdProdutos = 0;
    let nomeQtdProdutos = '';
    listaDeProdutosSelecionados.forEach((produto, index) => {
      valorTotal += produto.valor * produto.quantidade;
      qtdProdutos += produto.quantidade;
      const qtd =
        produto.quantidade === 1 ? produto.titulo : `${produto.titulo}s`;
      const ultimo =
        index === listaDeProdutosSelecionados.length - 1 ? ' ' : ', ';
      nomeQtdProdutos += `${produto.quantidade} ${qtd}${ultimo} `;
    });
    totalProdutos({
      valorTotalProdutos: valorTotal,
      qtdTotalProdutos: qtdProdutos,
      nomeQtdProdutos,
    });
  };

  chamaFuncRand = async () => {
    const {
      salvarListaProdutos,
      history,
      activeLoader,
      inactiveLoader,
    } = this.props;
    const reCaptcha = await window.grecaptcha.execute(
      process.env.REACT_APP_KEY_RECAPTCHA,
      {
        action: 'homepage',
      },
    );
    salvarListaProdutos(this.state.listaDeProdutosSelecionados);
    const { dados, tagEmMaos, tipoProduto } = JSON.parse(
      localStorage.getItem('proposta'),
    );
    activeLoader();
    veloeGraphQlApi(qtdProdutoFCG, {
      idProposta: dados.id,
      quantidadeIdentificadores: String(
        this.state.listaDeProdutosSelecionados[0].quantidade,
      ),
      tipoProduto: tipoProduto,
      tagEmMaos,
      captchaResponse: reCaptcha,
    })
      .then((data) => {
        const { dados, validatorResponse } = data['qtdProdutoFCG'];

        if (dados) {
          const quantidadeI = String(
            this.state.listaDeProdutosSelecionados[0].quantidade,
          );
          const proposta = JSON.parse(localStorage.getItem('proposta'));
          localStorage.setItem(
            'proposta',
            JSON.stringify({
              ...proposta,
              ...data['qtdProdutoFCG'],
              quantidadeI,
            }),
          );
          inactiveLoader();
          this.somaTotais();
          eventTrackBasic('clique:botao', 'continuar-contratacao', {
            qtdTag: this.state.listaDeProdutosSelecionados[0].quantidade,
          });

          let nextRoute = APP_PAGES.ONDE_USAR
          if(this.props.pedido.featureFlag?.enabled && parseInt(quantidadeI) === 1 && this.props.pedido.receberAdesivo === "sim") {
            nextRoute = APP_PAGES.DADOS_VEICULO
          }
           
          history.push(nextRoute);
        } else {
          const { errors } = validatorResponse;
          inactiveLoader();
          return errors.map((error) =>
            this.setState({
              textoTermos: error.message,
              openModalInformativo: true,
            }),
          );
        }
      })
      .catch((err) => {
        inactiveLoader();
        this.setState({
          textoTermos: err.message,
          openModalInformativo: true,
        });
      });
  };

  atualizaQtd = (event, id) => {
    this.state.listaDeProdutosSelecionados.forEach((produto) => {
      if (produto.id === id) {
        produto.quantidade = event;
      }
    });
    this.somaTotais();
  };

  montaTexto() {
    const { receberAdesivo, listaDeProdutos } = this.props.pedido;
    if (receberAdesivo === 'nao') return 'Quantos adesivos você possui?';
    if (listaDeProdutos.length === 1) {
      let produto = listaDeProdutos[0].titulo.toLowerCase();
      return `Quantos ${produto}s você deseja?`;
    }
    return 'Quantos produtos você deseja?';
  }
  render() {
    const {
      listaDeProdutosSelecionados,
      tags,
      quantidadeMaximaTagsPorClienteQuandoNaoTemTAG,
      quantidadeMaximaTagsPorClienteQuandoTemTAG,
      openModalInformativo,
      textoTermos,
    } = this.state;
    return (
      <div className="containerComponent">
        <div className="containerText">
          <div className="containerLabel">
            <label className="areaTexto">{this.montaTexto()}</label>
          </div>
        </div>
        <div className="containerArea">
          <div className="containerQtdProdutos">
            {listaDeProdutosSelecionados.map((item) => {
              return (
                <React.Fragment key={item.id}>
                  <Divider type="full" onBg="light" />
                  <Counter
                    size="xl"
                    onBg="light"
                    sufixes={[item.titulo, `${item.titulo}s`]}
                    min={1}
                    max={this.props.pedido.receberAdesivo === 'sim'
                    ? quantidadeMaximaTagsPorClienteQuandoNaoTemTAG
                    : quantidadeMaximaTagsPorClienteQuandoTemTAG}
                    type={COUNTER_TYPE.QUANTITY}
                    onChange={(e) => {
                      if (e > tags) {
                        eventTrackBasic(
                          'clique:icone',
                          'quantidade-adesivo:aumentar',
                        );
                      } else {
                        eventTrackBasic(
                          'clique:icone',
                          'quantidade-adesivo:diminuir',
                        );
                      }
                      this.setState({ tags: e });

                      this.atualizaQtd(e, item.id);
                    }}
                    value={item.quantidade}
                    id="counter-qtd"
                  />
                  <Divider type="full" onBg="light" />
                </React.Fragment>
              );
            })}

            <label className="lblQtdProdutos">
              {this.props.pedido.receberAdesivo === 'sim'
                ? `Você pode solicitar até ${quantidadeMaximaTagsPorClienteQuandoNaoTemTAG}`
                : `Você pode cadastrar até ${quantidadeMaximaTagsPorClienteQuandoTemTAG}`}
            </label>
            <div className="containerBotao">
              <Button
                className="stack-button"
                {...{
                  color: 'primary',
                  disabled: false,
                  label: 'Continuar',
                  id: 'btn-continuar',
                }}
                onClick={this.chamaFuncRand}
              />
            </div>
          </div>
        </div>
        {openModalInformativo &&
          modalInformativo(
            true,
            () => {
              this.setState({ openModalInformativo: false });
            },
            'Ops!',
            textoTermos,
          )}
        <ScriptTag
          type="text/javascript"
          src={`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ pedido }) => {
  return { pedido };
};

const mapDispatchToProps = (dispatch) => {
  return {
    salvarListaProdutos: (lista) => dispatch(salvarListaProdutos(lista)),
    totalProdutos: (infoTotal) => dispatch(totalProdutos(infoTotal)),
    salvarListaProdutosAsync: (lista) =>
      dispatch(salvarListaProdutosAsync(lista)),
    activeLoader: () => dispatch({ type: 'loader_active' }),
    inactiveLoader: () => dispatch({ type: 'loader_inactive' }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(QtdProduto));
